import { Grid } from '@mui/material';
import { UserRole, adminUserRoles } from '../../common/utils/enum';

function Dashboard(): JSX.Element {
  // const role = getUserRole();
  const role: UserRole = UserRole.Admin;
  return (
    <Grid>{adminUserRoles.includes(role) ? <Grid></Grid> : <Grid></Grid>}</Grid>
  );
}

export default Dashboard;
